// extracted by mini-css-extract-plugin
module.exports = {"clientList":"ClientList_clientList__fIM5E","errorView":"ClientList_errorView__8Ncc4"};